export let UserKind = /*#__PURE__*/function (UserKind) {
  UserKind["Unemployed"] = "unemployed";
  UserKind["Company"] = "company";
  UserKind["Teacher"] = "teacher";
  return UserKind;
}({});